import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import DashboardIcon from '@mui/icons-material/Dashboard';

import { StyledLink, StyledListItemText } from './styled';

export const mainListItems = (
  <>
    <StyledLink to="/categories">
      <ListItemButton>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <StyledListItemText primary="Certificate's Category" />
      </ListItemButton>
    </StyledLink>
    <StyledLink to="/certificates">
      <ListItemButton>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <StyledListItemText primary="Certificates" />
      </ListItemButton>
    </StyledLink>
    <StyledLink to="/products">
      <ListItemButton>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <StyledListItemText primary="Products" />
      </ListItemButton>
    </StyledLink>
    <StyledLink to="/messages">
      <ListItemButton>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <StyledListItemText primary="Messages" />
      </ListItemButton>
    </StyledLink>
  </>
);
